// TODO dynamic import currently not working because dev-tool.js not provided per cdn
function loadDevTools(callback) {
  // this allows you to explicity disable it in development for example
  const explicityDisabled =
    window.location.search.includes('dev-tools=false') ||
    window.localStorage.getItem('dev-tools') === 'false'

  const explicityEnabled =
    window.location.search.includes('dev-tools=true') ||
    window.localStorage.getItem('dev-tools') === 'true'

  if (
    !explicityDisabled &&
    (process.env.NODE_ENV === 'development' || explicityEnabled)
  ) {
    import('./dev-tools')
      .then((devTools) => devTools.install())
      .finally(callback)
  } else {
    callback()
  }
}

export default loadDevTools
